/**
 * Converts ranges to numbers for simpler comparison
 *
 * @internal
 **/
const index = range => {
  switch (range) {
    case 'xxl':
      return 7;

    case 'xl':
      return 6;

    case 'lg':
      return 5;

    case 'md':
      return 4;

    case 'sm':
      return 3;

    case 'xs':
      return 2;

    case 'xxs':
      return 1;

    case 'xxxs':
      return 0;

    default:
      throw new Error('Bad layout range: ', range);
  }
};
/**
 * Helper to check if a layout range is in-between two other ranges, inclusively.
 *
 * @param `actualRange` - the range to check (likely the active range)
 * @param `lowerRange` - the most narrow range against which to check `actualRange`
 * @param `upperRange` - the most wide range against which to check `actualRange` (must be equal to or more wide than `lowerRange`)
 *
 * @returns `true` if `actualRange` is the same as, or in-between the lower and upper ranges
 *
 * @throws Error
 *
 * This exception is thrown if any of the range parameters are not valid ranges.
 *
 * @example
 * ```
 * // true if `currentRange` is 'sm', 'md', or 'lg'
 * within(currentRange, 'sm', 'lg');
 * ```
 **/


export const within = (actualRange, lowerRange, upperRange) => {
  const actualRangeIndex = index(actualRange);
  return index(lowerRange) <= actualRangeIndex && actualRangeIndex <= index(upperRange);
};
/**
 * Helper to check if a range is at or above another range
 *
 * @param `actualRange` - the range to check (likely the active range)
 * @param `lowerBoundRange` - represents the most narrow range to compare to `actualRange`
 *
 * @returns `true` if `actualRange` is the same as, or wider than `lowerBoundRange`
 *
 * @throws Error
 *
 * This exception is thrown if any of the range parameters are not valid ranges.
 *
 * @example
 * ```
 * // true if `currentRange` is 'lg', 'xl', or 'xxl'
 * withinOrWiderThan(currentRange, 'lg');
 * ```
 **/

export const withinOrWiderThan = (actualRange, lowerBoundRange) => within(actualRange, lowerBoundRange, 'xxl');
//# sourceMappingURL=ranges.js.map